<router-outlet></router-outlet>

@if (session.loading$ | async) {
  <div id="loader-main">
    <div class="loader"></div>
    <span class="loader-label">{{ 'MODALBOXES.LOADING_DATA' | translate }}</span>
  </div>
}

<app-toast-config></app-toast-config>

